<div *ngIf="session">
  <div
    *ngIf="!isLoading"
    class="bg-cover bg-center h-screen w-screen"
    style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
  >
    <div
      class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
      >
        <div class="relative p-4 w-full max-w-md max-h-full">
          <div class="relative bg-white rounded-lg shadow">
            <div
              *ngIf="!isCalled && !error && !alreadyPresent"
              class="p-6 text-center"
            >
              <!-- Nom de l'activité -->
              <h2 class="mb-4 text-lg font-semibold text-gray-800">
                {{ activity.nomActivity }} <br />

                {{ activity.openDate | date: "dd MMMM yyyy" : "" : "fr" }}
              </h2>

              <!-- Icône -->
              <svg
                class="mx-auto mb-4 text-blue-500 w-12 h-12"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 8.5h.01M11 11h1v4m9-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>

              <!-- Message -->
              <p class="mb-4 text-sm text-gray-600">
                Merci de confirmer votre présence à cette activité en entrant
                l’adresse email reçue dans l’invitation.
              </p>

              <!-- Formulaire -->
              <form [formGroup]="emailForm" (ngSubmit)="confirmPresence()">
                <input
                  type="email"
                  formControlName="email"
                  placeholder="Adresse email"
                  class="w-full px-4 py-2 mb-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <!-- Erreurs -->
                <div
                  *ngIf="emailControl.touched && emailControl.invalid"
                  class="text-left text-sm text-red-600 mb-2"
                >
                  <div *ngIf="emailControl.errors?.['required']">
                    L’adresse email est obligatoire
                  </div>
                  <div *ngIf="emailControl.errors?.['email']">
                    Format d’email invalide
                  </div>
                </div>

                <!-- Responses -->
                <div class="text-left text-sm text-red-600 mb-2">
                  <div *ngIf="notIn">
                    Cette email n'est pas invite a cette activite!
                  </div>
                </div>

                <div>
                  <app-spinner *ngIf="showSpinner"></app-spinner>
                </div>
                <!-- Bouton -->
                <button
                  type="submit"
                  [disabled]="emailForm.invalid || isSubmitting"
                  class="w-full mt-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-medium py-2 rounded-lg transition"
                >
                  Confirmer ma présence
                </button>
              </form>
            </div>
            <div *ngIf="isCalled || alreadyPresent" class="p-6 text-center">
              <!-- Nom de l'activité -->
              <h2 class="mb-4 text-lg font-semibold text-gray-800">
                {{ activity.nomActivity }} <br />

                {{ activity.openDate | date: "dd MMMM yyyy" : "" : "fr" }}
              </h2>

              <!-- Icône -->
              <svg
                class="mx-auto mb-4 text-green-500 w-12 h-12"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12.75l2.25 2.25L15 10.5m5.25 1.5a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z"
                />
              </svg>

              <!-- Responses -->
              <div
                *ngIf="isCalled"
                class="text-center text-sm text-green-600 mb-2"
              >
                <div>Confirmation réussi!</div>
              </div>
              <div
                *ngIf="alreadyPresent"
                class="text-center text-sm text-green-600 mb-2"
              >
                <div>Votre présence a déjà été confirmée.</div>
              </div>
            </div>

            <div *ngIf="error" class="p-6 text-center">
              <!-- Nom de l'activité -->
              <h2 class="mb-4 text-lg font-semibold text-gray-800">
                {{ activity.nomActivity }} <br />

                {{ activity.openDate | date: "dd MMMM yyyy" : "" : "fr" }}
              </h2>

              <!-- Icône -->
              <svg
                class="mx-auto mb-4 text-red-500 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>

              <!-- Responses -->
              <div class="text-center text-sm text-red-600 mb-2">
                <div>
                  Nous rencontrons des soucis actuellemnet, merci de réessayer
                  plutard.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!session">
  <div
    class="bg-cover bg-center h-screen w-screen"
    style="background-image: url(&quot;assets/img/01-BG_AC_Force_N.png&quot;)"
  >
    <div
      class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
      >
        <div class="relative p-4 w-full max-w-md max-h-full">
          <div class="relative bg-white rounded-lg shadow">
            <div class="p-6 text-center">
              <!-- Nom de l'activité -->
              <h2 class="mb-4 text-lg font-semibold text-gray-800">
                {{ activity.nomActivity }} <br />

                {{ activity.openDate | date: "dd MMMM yyyy" : "" : "fr" }}
              </h2>

              <!-- Icône -->
              <svg
                class="mx-auto mb-4 text-red-500 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>

              <!-- Responses -->
              <div class="text-center text-sm text-red-600 mb-2">
                <div>La période de confirmation de présence est dépassée!</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
